import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M16.56 7.5 18 8.96l-7.436 7.54L6 11.873l1.44-1.46 3.124 3.165L16.559 7.5z",
		clipRule: "evenodd"
	})
});
export default SvgCheck;
